import React from "react";

import {
    FontAwesomeIcon
} from "@fortawesome/react-fontawesome";

import {
    faTriangleExclamation,
    faCircleInfo,
    faCircleCheck
} from "@fortawesome/free-solid-svg-icons";

export default function ConfirmationModal({

    open,
    title,
    message,

    confirmText,
    cancelText,

    onConfirm,
    onCancel,

    confirmColor,

    showCancelButton = true,

    type = "warning"

}) {

    /**************************************************************************
     * HIDE
     *************************************************************************/
    if (!open) {

        return null;

    }

    /**************************************************************************
     * ICON + COLOUR
     *************************************************************************/
    let icon =
        faTriangleExclamation;

    let iconColor =
        "#f59e0b";

    let glow =
        "drop-shadow(0 0 12px rgba(245,158,11,0.45))";

    if (type === "info") {

        icon =
            faCircleInfo;

        iconColor =
            "#5a9bd6";

        glow =
            "drop-shadow(0 0 12px rgba(90,155,214,0.45))";

    }
    else if (type === "success") {

        icon =
            faCircleCheck;

        iconColor =
            "#22c55e";

        glow =
            "drop-shadow(0 0 12px rgba(34,197,94,0.45))";

    }

    /**************************************************************************
     * DEFAULT BUTTON COLOUR
     *************************************************************************/
    const defaultConfirmColor =

        type === "info"
            ? "linear-gradient(180deg,#6baee6 0%, #5a9bd6 45%, #4a8ac4 100%)"

        : type === "success"
            ? "linear-gradient(180deg,#22c55e 0%, #16a34a 100%)"

        : "linear-gradient(180deg,#f59e0b 0%, #d97706 100%)";

    /**************************************************************************
     * RENDER
     *************************************************************************/
    return (

        <div
            style={{
                position: "fixed",
                inset: 0,
                background: "rgba(0,0,0,0.70)",
                backdropFilter: "blur(5px)",
                zIndex: 10000,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                padding: "20px"
            }}
        >

            <div
                style={{
                    width: "460px",
                    maxWidth: "95vw",
                    borderRadius: "18px",
                    overflow: "hidden",
                    background:
                        "linear-gradient(180deg,#07101c 0%, #02060d 100%)",
                    border:
                        "1px solid rgba(255,255,255,0.08)",
                    boxShadow:
                        "0 30px 80px rgba(0,0,0,0.6)"
                }}
            >

                {/* HEADER */}
                <div
                    style={{
                        padding: "26px 28px 18px 28px",
                        textAlign: "center",
                        borderBottom:
                            "1px solid rgba(255,255,255,0.08)"
                    }}
                >

                    {/* ICON */}
                    <div
                        style={{
                            marginBottom: "18px"
                        }}
                    >

                        <FontAwesomeIcon
                            icon={icon}
                            style={{
                                fontSize: "54px",
                                color: iconColor,
                                filter: glow
                            }}
                        />

                    </div>

                    {/* TITLE */}
                    <div
                        style={{
                            color: "#ffffff",
                            fontSize: "26px",
                            fontWeight: "700",
                            marginBottom: "10px"
                        }}
                    >
                        {title}
                    </div>

                    {/* MESSAGE */}
                    <div
                        style={{
                            color: "rgba(255,255,255,0.72)",
                            fontSize: "16px",
                            lineHeight: 1.5,
                            whiteSpace: "pre-line"
                        }}
                    >
                        {message}
                    </div>

                </div>

                {/* FOOTER */}
                <div
                    style={{
                        display: "flex",
                        justifyContent: "flex-end",
                        gap: "14px",
                        padding: "22px 26px",
                        background:
                            "linear-gradient(180deg,#07101c 0%, #03070d 100%)"
                    }}
                >

                    {/* CANCEL */}
                    {showCancelButton && (

                        <button
                            onClick={onCancel}
                            style={{
                                background:
                                    "linear-gradient(180deg,#6b7280 0%, #4b5563 100%)",
                                color: "#ffffff",
                                border: "none",
                                borderRadius: "12px",
                                padding: "14px 24px",
                                fontSize: "15px",
                                fontWeight: "700",
                                cursor: "pointer",
                                boxShadow:
                                    "0 8px 20px rgba(0,0,0,0.25)"
                            }}
                        >
                            {cancelText || "Cancel"}
                        </button>

                    )}

                    {/* CONFIRM */}
                    <button
                        onClick={onConfirm}
                        style={{
                            background:
                                confirmColor ||
                                defaultConfirmColor,
                            color: "#ffffff",
                            border: "none",
                            borderRadius: "12px",
                            padding: "14px 26px",
                            fontSize: "15px",
                            fontWeight: "700",
                            cursor: "pointer",
                            boxShadow:
                                "0 10px 26px rgba(0,0,0,0.35)"
                        }}
                    >
                        {confirmText || "OK"}
                    </button>

                </div>

            </div>

        </div>

    );

}